import { all } from 'redux-saga/effects';

import confirmaPreCadastroRenovacaoSaga from './confirmaPreCadastroRenovacao/saga';
import gerarRenachSaga from './gerarRenach/saga';

export default all([confirmaPreCadastroRenovacaoSaga, gerarRenachSaga]);
